import { getToApi } from './axios';

/**
 * Sugiere el nombre de quien recibe el servicio, a partir de su RUT.
 *
 * Devuelve `null` si esa persona no firmó antes en ese mismo cliente. No es un
 * buscador de RUT: la búsqueda está acotada al cliente de la visita justamente para
 * que la aplicación no se convierta en una guía de identidades consultable.
 */
export const sugerirRecepcionista = (rut, idCliente) =>
  getToApi(
    `/recepcionistas/sugerir?rut=${encodeURIComponent(rut)}&idCliente=${encodeURIComponent(
      idCliente
    )}`
  ).then((r) => r.data);
